<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
        <div
          class="card-body px-lg-5 py-lg-5 shadow"
          style="border:2px solid #d0d0d0;border-radius:10px;"
        >
          <div class="text-center" v-if="!resultado">
            <h3>Generación de nueva clave</h3>
            <p class="text-muted mb-4">
              Comercio asociado: definí la contraseña para acceder a la plataforma.
            </p>

            <password-validator
              v-model="model.password"
              @password-validated="updatePasswordValidity"
              placeholder="Nueva clave"
            ></password-validator>

            <div class="row form-group">
              <div class="col-md-12">
                <base-input
                  placeholder="Confirmar nueva clave"
                  class="input-group-alternative mb-3"
                  v-model="model.confirmPassword"
                  type="password"
                  addon-left-icon="fa fa-fw fa-unlock-alt"
                ></base-input>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12 text-center">
                <base-button
                  type="success"
                  size="lg"
                  @click="changePassword"
                  :disabled="model.passwordIsValid === false"
                >Cambiar clave</base-button>
              </div>
            </div>
          </div>

          <div class="text-center" v-if="resultado">
            <img src="@/assets/mail_verify.png" class="img-fluid" />
            <h3 class="rscolor">¡ Tu clave fue cambiada correctamente !</h3>
            <p>Ya podés utilizarla para ingresar a la aplicación con tu usuario de comercio asociado.</p>
            <div>
              <router-link
                to="/login"
                class="btn active btnVerify"
                role="button"
                aria-pressed="true"
              >Ir al login</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import PasswordValidator from "@/components/Custom/PasswordValidator";

export default {
  components: { PasswordValidator },
  name: "RecoveryPasswordComercioAsociado",
  data() {
    return {
      model: {
        password: "",
        confirmPassword: "",
        passwordIsValid: false
      },
      resultado: false
    };
  },
  methods: {
    updatePasswordValidity(isValid) {
      this.model.passwordIsValid = isValid;
    },
    changePassword() {
      if (this.model.password !== this.model.confirmPassword) {
        notificationHelpers.showError(
          "Advertencia!",
          "Los campos clave y repetir clave deben ser iguales",
          this
        );
        return;
      }

      if (!this.$route.query.code) {
        notificationHelpers.showError(
          "Advertencia!",
          "El enlace de cambio de contraseña es inválido o está incompleto.",
          this
        );
        return;
      }

      const context = this;
      axiosHelpers.axiosPostWithOutSecurityValidations(
        "AssociatedCommerce/ChangePassword",
        {
          Code: context.$route.query.code,
          Password: context.model.password
        },
        context,
        function(data) {
          context.resultado = data.ResponseVM.Resultado;
        }
      );
    }
  }
};
</script>

<style>
a {
  color: #ff4940;
}

a:hover {
  color: #c93961;
}

.btnVerify {
  background: rgba(255, 88, 85, 1);
  padding: 10px;
  border-radius: 5px;
  color: #fff;
  text-decoration: none;
  margin-top: 20px;
  margin-bottom: 20px;
  display: inline-block;
}

.btnVerify:hover {
  background: rgba(201, 57, 98, 1);
  color: #fff;
  text-decoration: none;
}

.rscolor {
  color: #ff4940;
}

h1,
h2,
h3,
h4,
h5 {
  color: #ff4940;
}
</style>
